import "babel-polyfill";
import "es6-promise";
import * as $ from "jquery";
import React from "react";
import { hydrate, render } from "react-dom";
import Router from "./components/Router";
import "react-select/dist/react-select.css";
import "video.js/dist/video-js.min.css";
import "videojs-youtube/dist/Youtube.min.js";
import "video.js/dist/video.min.js";
import "./css/style.css";
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from "./registerServiceWorker";
import sniffer from "./sniffer";

const rootElement = document.querySelector(".app");
// Snap hydrate
if (rootElement.hasChildNodes()) {
    hydrate(<Router />, rootElement);
} else {
    render(<Router />, rootElement);
}

// registerServiceWorker();
unregister();
sniffer();
window.jQuery = window.$ = $;

// Browsehappy
$(".browser").on("click", ".browsehappy-close", function(e) {
    e.preventDefault;
    $(".browser").removeClass("browser--active");
});



// WEBPACK FOOTER //
// ./src/index.js